export const RESET_PASSWORD = "RESET_PASSWORD"
export const RESET_PASSWORD_SUCCESSFUL = "RESET_PASSWORD_SUCCESSFUL"
export const RESET_PASSWORD_FAILED = "RESET_PASSWORD_FAILED"